const UPDATES = [
  {
    time: '15分钟前',
    title: '某知名导演新片选角内幕曝光，三位一线女星争抢女一号',
    tag: '独家',
    tagColor: 'bg-primary-500',
  },
  {
    time: '42分钟前',
    title: '顶流男团成员疑似恋情曝光，粉丝扒出多处同款证据',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    time: '1小时前',
    title: '年度热门综艺第二季官宣阵容，原班人马确认回归引期待',
    tag: '官宣',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '2小时前',
    title: '资深娱记爆料某对荧幕情侣实际已分手三个月，细节令人唏嘘',
    tag: '爆料',
    tagColor: 'bg-primary-500',
  },
  {
    time: '3小时前',
    title: '热门古装剧路透照流出，主演造型曝光后网友评论两极分化',
    tag: '路透',
    tagColor: 'bg-accent-500',
  },
  {
    time: '5小时前',
    title: '某女星出席活动生图翻车，工作室紧急发布精修图对比引群嘲',
    tag: '翻车',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '7小时前',
    title: '国际知名歌手宣布亚洲巡演加场，中国区售票时间已敲定',
    tag: '福利',
    tagColor: 'bg-primary-500',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            滚动更新
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新快讯</h2>
          <p className="text-sm text-foreground-500 mt-2">7×24小时不间断追踪，瓜不落地不停更</p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-0.5 bg-background-200"></div>
          <div className="space-y-5">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative group">
                <div className="absolute -left-[22px] md:-left-[26px] top-1.5 w-3 h-3 rounded-full border-2 border-primary-400 bg-background-50 group-hover:bg-primary-400 transition-colors"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="shrink-0 text-xs text-foreground-400 font-mono w-16">{item.time}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                  </div>
                  <span className={`shrink-0 self-start px-2 py-0.5 rounded text-xs font-medium text-background-50 ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}